import { ForegroundNotificationService } from './foregroundNotification.service';

export default angular
  .module('sfMobile.services.foreground-notification', [
    'pascalprecht.translate',
  ])
  .service('foregroundNotificationService', ForegroundNotificationService).name;
